import { render } from "./google-o-auth.vue?vue&type=template&id=7bdc8e4b&scoped=true"
import script from "./google-o-auth.vue?vue&type=script&lang=js"
export * from "./google-o-auth.vue?vue&type=script&lang=js"

import "./google-o-auth.vue?vue&type=style&index=0&id=7bdc8e4b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdc8e4b"]])

export default __exports__